import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import { IOptionCategory, IResponse } from '../models';

export const getOptionCategories = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  search?: string;
}): Promise<IResponse<IOptionCategory[]>> => {
  try {
    const { data } = await axios.get(`/api/option-category-notes`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getOptionCategories failed');
    return Promise.reject(error);
  }
};

export const getOptionCategory = async (categoryName: string): Promise<IOptionCategory> => {
  try {
    const { data } = await axios.get(`/api/option-category-notes/${categoryName}`);

    return data;
  } catch (error: any) {
    logError(error, 'getOptionCategory failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createOptionCategory = async (body: IOptionCategory): Promise<string> => {
  try {
    const { data } = await axios.post(`/api/option-category-notes`, body);

    return data;
  } catch (error: any) {
    logError(error, 'createOptionCategory failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateOptionCategory = async (
  categoryName: string,
  body: {
    description: string;
  }
): Promise<string> => {
  try {
    const { data } = await axios.put(`/api/option-category-notes/${categoryName}`, body);

    return data;
  } catch (error: any) {
    logError(error, 'updateOptionCategory failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteOptionCategory = async (categoryName: string): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/option-category-notes/${categoryName}`);
    return data;
  } catch (error: any) {
    logError(error, 'deleteOptionCategory failed');
    return Promise.reject(error?.response?.data);
  }
};
